import { forwardRef } from "react";

import PropTypes from "prop-types";

import { CustomInputField } from "../custom-input-field";
import CustomNumberFormat from "./custom-number-format";

export const CustomNumberField = forwardRef(
  ({ onChange, value, disabled, InputProps, inputProps, ...props }, ref) => (
    <CustomInputField
      ref={ref}
      value={value}
      onChange={onChange}
      disabled={disabled}
      inputProps={{
        allowNegative: false,
        style: { textAlign: "right" },
        ...inputProps,
      }}
      InputProps={{
        inputComponent: CustomNumberFormat,
        ...InputProps,
      }}
      {...props}
    />
  )
);

CustomNumberField.displayName = "CustomNumberField";

CustomNumberField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  InputProps: PropTypes.object,
  inputProps: PropTypes.object,
};
